import * as React from "react";
import { IBudgetDetails } from "../../../../config/budget";
import { fetchBudgetDetails } from "../../../../stores/budgets";
import { useParams } from "react-router-dom";
import { PageLoader } from "../../../Components/PageLoader";
import Error from "../../../Components/Error";
import { PageItem } from "../../../Components/PageItem";
import { BudgetDetailsUsages } from "../Components/BudgetDetailsUsages/BudgetDetailsUsages";
import { YearSelection } from "./YearSelection";
import moment from "moment";

export const BudgetView = () => {
    const {id} = useParams();

    const [loading, setLoading] = React.useState<boolean>(true);
    const [error, setError] = React.useState<boolean>(false);
    const [budget, setBudget] = React.useState<IBudgetDetails>();
    const [year, setYear] = React.useState<number>();

    const handleYearChange = (year: number) => {
        setYear(year);
    };

    React.useEffect(() => {
        setLoading(true);
        fetchBudgetDetails(id!)
            .then(res => setBudget(res))
            .catch(() => setError(true))
            .finally(() => setLoading(false));
    }, [id]);

    if (loading) {
        return (
            <PageLoader />
        );
    }

    if (error) {
        return (
            <Error />
        );
    }

    if (!budget) {return null}

    return (
        <PageItem title={`Budget: ${budget?.name}`}>
            <YearSelection budget={budget} onChange={handleYearChange} />
            <BudgetDetailsUsages budget={budget} year={year || moment().year()} />
        </PageItem>
    );
}